import { render } from "./StoreEventNotes.vue?vue&type=template&id=5e534435"
import script from "./StoreEventNotes.vue?vue&type=script&lang=js"
export * from "./StoreEventNotes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__